import { EncoderObject } from "../Types/AllTypes";

const HuffmanCoding: EncoderObject = {
  name: "Huffman Coding",
  code: "HC"
}

const LZW: EncoderObject = {
  name: "LZW",
  code: "LZW"
}

const RunLengthEncoding: EncoderObject = {
  name: "Run Length Encoding",
  code: "RLE"
}

const BurrowsWheelerTransform: EncoderObject = {
  name: "Burrows-Wheeler Transform",
  code: "BWT"
}

const MoveToFront: EncoderObject = {
  name: "Move To Front",
  code: "MTF"
}

const DeltaEncoding: EncoderObject = {
  name: "Delta Encoding",
  code: "DE"
}

const LZ77: EncoderObject = {
  name: "LZ77",
  code: "LZ77"
}

const LZ78: EncoderObject = {
  name: "LZ78",
  code: "LZ78"
}


export const allEncoders: EncoderObject[] = [
  HuffmanCoding,
  LZW,
  RunLengthEncoding,
  BurrowsWheelerTransform,
  MoveToFront,
  DeltaEncoding,
  LZ77,
  LZ78
]

export const groupedEncoders = [
  {
    name: 'Transform',
    code: 'TR',
    items: [
      MoveToFront,
      BurrowsWheelerTransform,
      DeltaEncoding,
    ]
  },
  {
    name: 'Dictionary',
    code: 'DB', // Dictionary Based
    items: [
      LZ77,
      LZ78,
      LZW,
    ]
  },
  {
    name: 'Entropy',
    code: 'EB', // Entropy Based
    items: [
      HuffmanCoding
    ]
  },
  {
    name: 'Misc',
    code: 'MC', // Entropy Based
    items: [
      RunLengthEncoding
    ]
  }
];